import React, { useEffect, useState } from "react";
import Navbar from "components/Navbar";

import { store } from "services/firebase";
import { getConfirmedOrdersQty } from "utils/orders";
import Card from "../Card";

export default function List(props) {
    const { isLogged } = props;

    const [orders, setOrders] = useState([]);

    function updateLocalOrders(orders) {
        localStorage.setItem("lastRequest", Date.now());
        localStorage.setItem("orders", JSON.stringify(orders));
        setOrders(orders);
    }

    async function removeStoreOrder(ticketId) {
        const orderDoc = store.collection("INGRESSOS").doc(ticketId);
        await orderDoc.delete()
            .then(() => {
                console.log("Document successfully deleted!");

                const newOrders = orders.filter(order => order.ticketId !== ticketId);
                updateLocalOrders(newOrders);
            })
            .catch((error) => {
                console.error("Error removing document: ", error);
            });
    }

    async function getPedidosFromFirebase() {
        const pedidos = store.collection("INGRESSOS");

        let newData = [];
        await pedidos.get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    newData.push(doc.data());
                });

                console.log("data requested");
                updateLocalOrders(newData);
            })
            .catch(error => console.log(error));
    }

    useEffect(() => {
        const lastRequest = localStorage.getItem("lastRequest");

        if (lastRequest === null) getPedidosFromFirebase();

        const now = Date.now();
        const diff = (now - lastRequest) / 1000; // diff is measured in seconds

        const canRequest = diff > 120; // can request after 120 seconds

        if (canRequest) {
            getPedidosFromFirebase();
        } else {
            setOrders(JSON.parse(localStorage.getItem('orders')));
        }
    }, []);

    const handleDelete = (ticketId) => {
        const isConfirmed = window.confirm('Tem certeza que deseja remover o pedido?');
        if (isConfirmed) {
            removeStoreOrder(ticketId);
        }
    };

    return (
        <>
            <Navbar isLogged={isLogged} />
            <section className="py-3">
                <div className="container text-center">
                    <h2>Relatório de Inscrições</h2>
                </div>
                <div className="container mb-3">
                    <p className="mb-1">INSCRIÇÕES FEITAS: {orders.length}</p>
                    <p className="mb-1">PAGAMENTOS PENDENTES: {orders.length - getConfirmedOrdersQty(orders)}</p>
                    <p className="mb-1">PAGAMENTOS CONFIRMADOS: {getConfirmedOrdersQty(orders)}</p>
                </div>
                <div className="container">
                    <div className="row">
                        {orders?.map((order, index) => <Card order={order} index={index} handleDelete={handleDelete} />)}
                    </div>
                </div>
            </section>
        </>
    );
}
